export default __webpack_public_path__ + "static/media/articles-lt.e1f47f2c.png";